import { render } from "./W3Autocomplete.vue?vue&type=template&id=6a0216db&ts=true"
import script from "./W3Autocomplete.vue?vue&type=script&lang=ts"
export * from "./W3Autocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__